
export function formatToTwDate(date) {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear() - 1911;
    return `${year}/${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}`;
}

export function formatToTwDateInterval(twDateString, interval) {
    const i = twDateString.length;
    const day = twDateString.substring(i - 2, i);
    const month = twDateString.substring(i - 4, i - 2);
    const year = twDateString.substring(0, i - 4);
    return `${year}${interval}${month}${interval}${day}`;
}

export function formatToTwDateTWInterval(twDateString) {
    const i = twDateString.length;
    const day = twDateString.substring(i - 2, i);
    const month = twDateString.substring(i - 4, i - 2);
    const year = twDateString.substring(0, i - 4);
    return `${year}年${month}月${day}日`;
}
